import { render } from "./detallescuentaspedido.vue?vue&type=template&id=73508903"
import script from "./detallescuentaspedido.vue?vue&type=script&lang=js"
export * from "./detallescuentaspedido.vue?vue&type=script&lang=js"

import "./detallescuentaspedido.vue?vue&type=style&index=0&id=73508903&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__